module.exports = __webpack_public_path__ + "static/media/setpass.50aa1950.svg";